import React from 'react'
import { Button, Tooltip } from '@intelie/ui'

import i18n from 'live/services/i18n'

import { ApprovalOverviewSidebarButtonRegistry } from 'plugin-joblog/shared/lib/approval-overview-sidebar-button-registry'
import { canAccessPSR } from '../permissions/permissions'

const registerApprovalOverviewSidebarButton = (fracEventAlias: string, postStageReportAlias: string) =>
    ApprovalOverviewSidebarButtonRegistry.register({
        title: i18n('Post Stage Report'),
        Component: props => {
            if (!canAccessPSR()) return null

            const { type, eventUid, crewUID } = props.eventData
            const isStage = type === 'StageKPIs'

            return isStage ? (
                <Tooltip overlay={'Post stage report page'} placement="top">
                    <Button
                        style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            lineHeight: '20px',
                            padding: '6px 12px',
                            height: '32px',
                            border: '1px solid var(--gray-500)',
                            borderRadius: '4px'
                        }}
                        variant="default"
                        size="md"
                        onClick={() => {
                            const basePath = window.location.pathname
                            const hash = `/${fracEventAlias}/${postStageReportAlias}/${crewUID}/run/${eventUid}`

                            const url = `${basePath}#${hash}`

                            window.open(url, '_blank', 'noopener,noreferrer')
                        }}
                    >
                        <i style={{ color: 'var(--gray-800)' }} className="far fa-file-alt" />
                    </Button>
                </Tooltip>
            ) : null
        }
    })

export default registerApprovalOverviewSidebarButton
